import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-stock-control',
  templateUrl: './stock-control.component.html',
  styleUrls: ['./stock-control.component.scss'],
})
export class StockControlPage implements OnInit {
  destroyed$ = new Subject<boolean>();
  translations: any;
  stockForm: FormGroup | any;
  previousData: any;
  originalValues: any;

  constructor(
    translate: TranslateService,
    public modalController: ModalController,
    private fb: FormBuilder,
  ) {
    translate
      .get(['ACTIONS', 'STORE_MODULE', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit() {
    this.stockForm = this.fb.group({
      addControl: [false],
      quantity: ['']
    });

    if(this.previousData){
      console.log('this.previousData: ', this.previousData);
      this.stockForm.patchValue({
        addControl: !this.previousData.unlimited,
        quantity: this.previousData.quantity
      });
    }

    this.originalValues = this.stockForm.value;

    this.stockForm.get('addControl')?.valueChanges.subscribe((value) => {
      const quantityControl = this.stockForm.get('quantity');

      if (value) {
        quantityControl?.addValidators(Validators.required);
      } else {
        quantityControl?.clearValidators();
      }
      quantityControl?.updateValueAndValidity();
    });
  }

  isFormValid(): boolean {
    return this.stockForm.valid && this.stockForm.dirty;
  }

  close() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  updateData(){
    if (this.isFormValid()) {
      console.log('Formulario actualizado:', this.stockForm.value);
      this.originalValues = this.stockForm.value; // Guardar nuevos valores
      this.stockForm.markAsPristine(); // Resetear el estado dirty
      this.modalController.dismiss({
        value: this.stockForm.value
      });
    }
  }

}
